import {
  BulkBankTransferError,
  BulkBankTransferFileParseResult,
  BulkBankTransferParsingError,
} from '__generated__/GQL';
import LOCALE from 'common/locale';

import { formatAmount } from '../../../../../../../../../common/formatAmount';
import {
  MAXIMUM_BULK_TRANSFERS_COUNT,
  MAXIMUM_TRANSFER_WITHOUT_RECEIPT_AMOUNT,
} from '../../../constants';
import {
  globalErrorsLocales,
  transferErrorLocales,
} from './bulkTransferErrorsLocales';

interface composeErrorDetailsArgs {
  code: BulkBankTransferParsingError;
  transferIndexes: BulkBankTransferError['transferIndexes'];
  transfers: BulkBankTransferFileParseResult['transfers'];
  totalAmount: BulkBankTransferFileParseResult['totalAmount'];
}

const composeErrorMessage: (
  errorDetails: composeErrorDetailsArgs,
) => string = ({ code, totalAmount, transferIndexes, transfers }) => {
  if (transferIndexes === null) {
    return globalErrorsLocales.formatString(
      globalErrorsLocales[code] as string,
      {
        maxTransfersCount: `${MAXIMUM_BULK_TRANSFERS_COUNT}`,
        totalAmount: `**${formatAmount({
          forcePlusSign: false,
          value: totalAmount,
        })}**`,
      },
    ) as string;
  }
  const recipientNames = transferIndexes.map(
    // @ts-expect-error Object is possibly 'undefined'.
    (idx) => `**${transfers[idx].bankTransferRecipient.name}**`,
  );

  const message = transferErrorLocales.formatString(
    // @ts-expect-error Object is possibly 'undefined'.
    transferErrorLocales[code][
      recipientNames.length > 1 ? 'many' : 'one'
    ] as string,
    {
      maxAmount: formatAmount({
        forcePlusSign: false,
        value: MAXIMUM_TRANSFER_WITHOUT_RECEIPT_AMOUNT,
        withNoMinorUnitDigits: true,
      }),
      recipientNameOrNames: new Intl.ListFormat(LOCALE).format(recipientNames),
    },
  ) as string;

  return message;
};

export default composeErrorMessage;
